import type { MapDefinition, PathLayer } from '../../model/gamestate/GameState';
import {
  getPathTileAtlasDefinition,
  type PathTileAutotileProfileId,
  type PathTileAtlasId,
} from '../pathTileRegistry';
import { resolveCanonicalAtlasId } from './pathTileLayers';

export function findAtlasLayer(map: MapDefinition, atlasId: PathTileAtlasId): PathLayer | null {
  return (map.pathLayers ?? []).find((layer) => resolveCanonicalAtlasId(layer) === atlasId) ?? null;
}

export function supportsSquarePathAutotiling(map: MapDefinition, atlasId: PathTileAtlasId): boolean {
  return getPathAutotileProfile(map, atlasId) === 'square-path-v1';
}

export function supportsHexPathAutotiling(map: MapDefinition, atlasId: PathTileAtlasId): boolean {
  return getPathAutotileProfile(map, atlasId) === 'hex-path-v1';
}

export function getPathAutotileProfile(map: MapDefinition, atlasId: PathTileAtlasId): PathTileAutotileProfileId | null {
  return getPathTileAtlasDefinition(atlasId, map.gridType)?.autotileProfile ?? null;
}

export function isWithinMap(map: MapDefinition, x: number, y: number): boolean {
  return x >= 0 && x < map.width && y >= 0 && y < map.height;
}

export function continuesOffMap(map: MapDefinition, x: number, y: number): boolean {
  if (x < 0) {
    return y >= 0 && y < map.height;
  }
  if (x >= map.width) {
    return y >= 0 && y < map.height;
  }
  if (y < 0) {
    return x >= 0 && x < map.width;
  }
  if (y >= map.height) {
    return x >= 0 && x < map.width;
  }
  return false;
}
